<template>
  <div class="commonIndex">
    <main>
      <!-- <notice v-if="$store.getters.checkNotice"></notice> -->
      <firstRow
        :class="{ 'fillet' : !$store.getters.checkNotice, 'empty': !ticketInfoList.length }"
        :fullTicketInfo="fullTicketInfo"
        @clickPay="nextStep"
        :fullPrice="Number(fullPrice)">
      </firstRow>
      <ticketType
        ref="DOMticketType"
        @changeSeasonTicket="changeSeasonTicket"
        :saleDateInfos="saleDateInfos"
        v-if="ticketInfoList.length">
      </ticketType>
      <numberController v-if="ticketInfoList.length" @changePeopleNumber="changePeopleNumber" :ticketInfoList="ticketInfoList"></numberController>
      <emptyContent text="There are currently no tickets available." v-else />
    </main>
    <calculationAction
      nextStepName="Next"
      @nextStep="nextStep"
      :fullPrice="Number(fullPrice)"
      :controllerNumber="controllerNumber"
      ></calculationAction>
      <yzyPopup title="prompt" :message="yzyTips" :show="yzyShow" @closePopup="closeToNext"></yzyPopup>
  </div>
</template>

<script>
import firstRow from "@/components/buyTickets/common/firstRowEn";
import { getProductMulti } from "@/service/buyTickets/common.js";
import ticketType from "@/components/buyTickets/shoppingCart/ticketTypeEn";
import numberController from "@/components/buyTickets/shoppingCart/numberControllerEn";
import calculationAction from "@/components/buyTickets/shoppingCart/calculationActionEn";
import yzyPopup from '@/components/buyTickets/common/yzyPopupEn'

export default {
  name: "touristhmtShoppingCart",
  data(){
    return {
       yzyTips:'Tourists who buy tickets in the park online must have purchased large tickets. Tourists who do not purchase large tickets cannot buy tickets. Please scan the code at the park site to buy tickets of the day',
      yzyShow:false,
      // 可展示为购物车的索引
      fullTicketInfo: {},
      // 一组票的数据
      ticketInfoList: [null],
      saleDateInfos: [],
      controllerNumber: [],
      fullPrice: 0,
      currentSeason: this.$getCurrentSeason(),
      checkPreSaleDate: this.$checkPreSaleDate(),
      ticketPool: {
        currentSeasonTicketInfoList: [],
        reserveSeasonTicketInfoList: [],
      }
    }
  },
  created(){
    this.resetAction();
    this.getTicketList();
  },
  methods: {
    resetAction(){
      const orderinformation = window.sessionStorage.getItem('orderinformation') || false;
      const controllerNumber = window.sessionStorage.getItem('controllerNumber') || false;
      const oftenContacts = window.sessionStorage.getItem('oftenContacts') || false;
      orderinformation && window.sessionStorage.removeItem('orderinformation');
      controllerNumber && window.sessionStorage.removeItem('controllerNumber');
      oftenContacts && window.sessionStorage.removeItem('oftenContacts');
    },
    nextStep(){
      // 当天日期没有被选择
      if(!this.$refs.DOMticketType.todayList.datePeriodInfos.length)return this.$toast("Please select a date");
      // 没选时段
      if (!this.$refs.DOMticketType.currentTime)return this.$toast("Please select a time slot");
      // 判断要展开，并且有长度
      if(!this.controllerNumber.length)return this.$toast("Please select the number of tickets.");
      // 并且必须有数量
      if(!this.controllerNumber.some(v => v.count > 0))return this.$toast("Please select the number of tickets.");
      const total = this.controllerNumber.reduce((cur, pre) => {
        return cur += pre.count
      }, 0);
      const quantity = Number(this.$store.state.quantity);
      if(total > quantity)return this.$toast(`${quantity} tourists at maximum for each order.`);
      // const { currentDays, currentIndex2 } = this.$refs.DOMticketType;
      // const { datePeriodInfos } = currentDays;
      // const selectDate = {
      //   saleDate: currentDays.saleDate,
      //   datePeriodInfo: datePeriodInfos[currentIndex2]
      // };
      const { currentDays, currentIndex2,isNeedPeriod } = this.$refs.DOMticketType;
      const { datePeriodInfos } = currentDays;
      const selectDate = {
        saleDate: currentDays.saleDate,
        datePeriodInfo: datePeriodInfos[currentIndex2],
        isNeedPeriod:isNeedPeriod
      };
      window.sessionStorage.setItem('orderinformation', JSON.stringify({
        controllerNumber: this.controllerNumber,
        selectDate,
        fullTicketInfo: this.fullTicketInfo,
      }));
      const { ticketcode } = this.$route.query;
      console.log(ticketcode)
      if(ticketcode == 'tg_01_100_01' || ticketcode == 'tg_01_100_02' || ticketcode == 'tg_01_100_03' || ticketcode == 'tg_01_100_04' || ticketcode == 'tg_01_100_05' || ticketcode == 'tg_01_100_01_01' || ticketcode == 'tg_01_100_02_01') {
        this.yzyShow = true
        console.log(this.yzyShow)
      }else{
        this.$beyondHiding(false);
        this.$router.push('/touristhmtplaceorderEn')
      }
    },
    closeToNext(){
      this.yzyShow = false
      this.$router.push('/touristhmtplaceorderEn');
    },
    // 更新列表数据
    changePeopleNumber({ controllerNumber }){
      this.controllerNumber = controllerNumber;
    },
    setFullTicketInfo(ticketWindow){
      const fullData = Object.values(ticketWindow).reduce((pre, cur) => {
        cur.forEach(v => {
          pre.push(v)
        });
        return pre;
      }, []);
      const fullTicketInfo = fullData.find(({ code }) => code === this.$route.query.ticketcode)
      this.fullTicketInfo = fullTicketInfo;
    },
    ticketInSaleDateInfos(saleDateInfos,ticketInfo){
      const lpflag = ticketInfo.attrInfos.some(item=>item.key=='coupon' && item.friendlyName == 'SCOPE')
      saleDateInfos.forEach(item => {
        // item.ticketState = item.datePeriodInfos.some((v) => parseInt(v.resourceCount) > 0);
         if(ticketInfo.needDatePeriod == 'true'){
          item.ticketState = item.datePeriodInfos.some((v) => parseInt(v.resourceCount) > 0);
        }else{
          item.ticketState = true
        }
        item.needDatePeriod = ticketInfo.needDatePeriod  == 'true' ? true : false
        if(lpflag){
          item.islp = true
        }else{
          item.islp = false
        }
        if(!item.dateType)item.dateType = 'current';
      });
      this.saleDateInfos = saleDateInfos;
    },
    async bridgingOffPeakSeasonDate(saleDateInfos,ticketInfo){
      const needFillingDays = parseInt(process.env.VUE_APP_PRE_SALE_QUANTITY) - saleDateInfos.length;
      const { ticketcode } = this.$route.query;
      const reserveTicketWindow = this.$store.state.reserveTicketWindow;
      const { productSns } = Object.values(reserveTicketWindow).flat().find(item => item.code === ticketcode);
      const result = await getProductMulti({ productSns });
      const reserveSeasonTicketInfoList = result.data;
      if(reserveSeasonTicketInfoList.length != 0) {
        this.ticketPool.reserveSeasonTicketInfoList = reserveSeasonTicketInfoList;
        const reserveSaleDateInfos = reserveSeasonTicketInfoList[0].saleDateInfos.splice(0, needFillingDays);
        saleDateInfos.forEach(item => item.dateType = 'current')
        reserveSaleDateInfos.forEach(item => item.dateType = 'reserve')
        const newSaleDateInfos = saleDateInfos.concat(reserveSaleDateInfos);
        this.ticketInSaleDateInfos(newSaleDateInfos,ticketInfo)
      }else{
        this.ticketInSaleDateInfos(saleDateInfos,ticketInfo);
      }
    },
    changeSeasonTicket(currentDays){
      if(!this.checkPreSaleDate)return;
      const { dateType } = currentDays;
      if(dateType === 'current'){
        this.ticketInfoList = this.ticketPool.currentSeasonTicketInfoList;
        this.setFullTicketInfo(this.$store.state.ticketWindow);
      }else{
        this.ticketInfoList = this.ticketPool.reserveSeasonTicketInfoList;
        this.setFullTicketInfo(this.$store.state.reserveTicketWindow);
      }
    },
    async getTicketList(){
      const ticketList = this.$store.state.ticketWindow;
      console.log(ticketList)
      this.setFullTicketInfo(ticketList);
      const productSns = this.fullTicketInfo.productSns;
      const result = await getProductMulti({ productSns });
      this.ticketInfoList = result.data
      this.ticketPool.currentSeasonTicketInfoList = JSON.parse(JSON.stringify(this.ticketInfoList));
      const productSn = this.ticketInfoList[0].productSn;
      const {
        policyGuaranteeTicketlistWindowList,
        freeIndividualticketTicketlistWindowList,
        freeHmtticketlistWindowList,
        deheParkIndividualticketlistWindowList,
        deheParkForeignNationalityticketlistWindowList,
        buddhaFragrancePavilionIndividualticketlistWindowList,
        buddhaFragrancePavilionForeignNationalityticketlistWindowList,
        suZhouStreetIndividualticketlistWindowList,
        suZhouStreetForeignNationalityticketlistWindowList,
        museumticketlistIndividualticketlistWindowList,
        museumticketlistForeignNationalityticketlistWindowList,
        nryWindowList,
      } = this.$store.state.ticketWindow;
      const checkPolicyGuaranteeTicket = policyGuaranteeTicketlistWindowList.some((good) => good.productSns.some((sn) => productSn === sn));
      const checkFreeIndividualticketTicket = freeIndividualticketTicketlistWindowList.some((good) => good.productSns.some((sn) => productSn === sn));
      const checkFreeHmtticket = freeHmtticketlistWindowList.some((good) => good.productSns.some((sn) => productSn === sn));
      const checkDeheParkIndividualticket = deheParkIndividualticketlistWindowList.some((good) => good.productSns.some((sn) => productSn === sn));
      const checkDeheParkForeignNationalityticket = deheParkForeignNationalityticketlistWindowList.some((good) => good.productSns.some((sn) => productSn === sn));
      const checkBuddhaFragrancePavilionIndividualticket = buddhaFragrancePavilionIndividualticketlistWindowList.some((good) => good.productSns.some((sn) => productSn === sn));
      const checkBuddhaFragrancePavilionForeignNationalityticket = buddhaFragrancePavilionForeignNationalityticketlistWindowList.some((good) => good.productSns.some((sn) => productSn === sn));
      const checkSuZhouStreetIndividualticket = suZhouStreetIndividualticketlistWindowList.some((good) => good.productSns.some((sn) => productSn === sn));
      const checkSuZhouStreetForeignNationalityticket = suZhouStreetForeignNationalityticketlistWindowList.some((good) => good.productSns.some((sn) => productSn === sn));
      const checkMuseumticketlistIndividualticket = museumticketlistIndividualticketlistWindowList.some((good) => good.productSns.some((sn) => productSn === sn));
      const checkMuseumticketlistForeignNationalityticket = museumticketlistForeignNationalityticketlistWindowList.some((good) => good.productSns.some((sn) => productSn === sn));
      const checkNryWindowList = nryWindowList.some((good) => good.productSns.some((sn) => productSn === sn));
      if(
        !this.checkPreSaleDate ||
        checkFreeIndividualticketTicket ||
        checkFreeHmtticket ||
        checkDeheParkIndividualticket ||
        checkDeheParkForeignNationalityticket ||
        checkBuddhaFragrancePavilionIndividualticket ||
        checkBuddhaFragrancePavilionForeignNationalityticket ||
        checkSuZhouStreetIndividualticket ||
        checkSuZhouStreetForeignNationalityticket ||
        checkMuseumticketlistIndividualticket ||
        checkMuseumticketlistForeignNationalityticket ||
        checkNryWindowList ||
        checkPolicyGuaranteeTicket){
        this.ticketInSaleDateInfos(result.data[0].saleDateInfos,result.data[0]);
      }else{
        this.bridgingOffPeakSeasonDate(result.data[0].saleDateInfos,result.data[0])
      };
    },
  },
  watch: {
    controllerNumber: {
      handler(newValue){
        const fullPrice = newValue.reduce((total, currentValue, currentIndex, arr) => {
          total += Number(currentValue.salePrice) * currentValue.count;
          return total;
        }, 0);
        this.fullPrice = String(fullPrice.toFixed(2)).padStart(2, 0);
      },
      deep: true,
    }
  },
  components: {
    firstRow,
    ticketType,
    numberController,
    calculationAction,
    yzyPopup
  },
};
</script>

<style scoped lang="less">
.empty{
  /deep/ .content-box{
    border-bottom: none;
  }
}

main{
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  /deep/ .booth {
    padding-bottom: 2.026667rem;
  }
};

.fillet{
  border-radius: 0.16rem 0.16rem 0 0;
}
</style>
